import { Commit, Dispatch } from 'vuex';
import { login, getStaffInfo } from '@/api/auth';
import {
  setToken, removeToken, getToken, removeLocation, setLocation,
} from '@/utils/storage';

const State: any = {
  token: '',
  username: '',
  shortName: '',
  roles: [],
  locationId: '',
  locationCode: '',
  locationName: '',
};

const mutations: any = {
  SET_TOKEN(state: any, token: string) {
    state.token = token;
  },

  SET_USERNAME(state: any, name: string) {
    state.username = name;
  },

  SET_SHORTNAME(state: any, shortName: string) {
    state.shortName = shortName;
  },

  SET_LOCATION_CODE(state: any, locationCode: string) {
    state.locationCode = locationCode;
  },

  SET_LOCATION_NAME(state: any, locationName: string) {
    state.locationName = locationName;
  },

  SET_ROLES(state: any, roles: number[]) {
    state.roles = roles;
  },
};

const actions: any = {
  // Login
  async login(
    context: { commit: Commit; dispatch: Dispatch },
    userInfo: { username: string; password: string },
  ) {
    const { username, password } = userInfo;
    const { data } = await login({ username, password });
    setToken(data.access_token);
    context.commit('SET_TOKEN', data.access_token);
    await context.dispatch('getUserInfo');
  },
  // Resume login
  async resumeLogin(context: { commit: Commit; dispatch: Dispatch }) {
    context.commit('SET_TOKEN', getToken());
    await context.dispatch('getUserInfo');
  },
  // Logout
  logout(context: { commit: Commit }) {
    removeToken();
    removeLocation();
    context.commit('SET_TOKEN', '');
  },
  // Get staff info
  async getUserInfo(context: { commit: Commit }) {
    const { data } = await getStaffInfo();
    const shortName = data.payroll_name.replace(/\s*/g, '').substring(0, 2);
    context.commit('SET_USERNAME', data.payroll_name);
    context.commit('SET_SHORTNAME', shortName);
    context.commit('SET_LOCATION_CODE', data.location.location_code);
    context.commit('SET_LOCATION_NAME', data.location.name);
    setLocation(data.location.location_code);
    const roles: number[] = [];
    data.info.forEach((role: any) => roles.push(role.role_type));
    context.commit('SET_ROLES', roles);
  },
  // Set location
  setLocation(
    context: { commit: Commit },
    location: { locationCode: string; locationName: string },
  ) {
    context.commit('SET_LOCATION_CODE', location.locationCode);
    context.commit('SET_LOCATION_NAME', location.locationName);
    setLocation(location.locationCode);
  },
};

const getters: any = {
  token: (state: any) => state.token,
  locationCode: (state: any) => state.locationCode,
};

export default {
  namespaced: true,
  state: State,
  mutations,
  actions,
  getters,
};
